export default "__VITE_ASSET__DqQ$kVDU__"